import DropdownItem from "@/components/DropdownItem";
import Modal from "@/components/Modal";
import Link from "@/components/MyLink";
import { useApp, useAppStore } from "@/store/app";
import { useReplicacheSetLists } from "@/store/replicache";
import fromNowOrNow from "@/utils/fromNowOrNow";
import type { SetList } from "@/utils/types";
import { isEmpty } from "lodash";
import { MdModeEdit, MdMoreVert, MdOutlineDelete } from "react-icons/md";
import shallow from "zustand/shallow";

export default function SetLists() {
  const { setLists } = useReplicacheSetLists();
  const { setListModify } = useApp();
  const { user } = useAppStore(
    ({ user }) => ({
      user,
    }),
    shallow,
  );
  const { setListRemove } = useApp();
  const setListsArray = Object.values(setLists).sort(
    (a, b) => b.updated_timestamp - a.updated_timestamp,
  );

  const handleClickRename = (setList: SetList) => {
    const currentTitle = setList.title;
    const title = window.prompt("Set Name", currentTitle);
    console.debug("handleClickRename", {
      title,
      currentTitle,
    });
    if (!title || title === currentTitle) return;
    setListModify({ ...setList, title });
  };

  //console.debug("🔤 SetLists", setLists, setListsArray);

  const handleDelete = (setList: SetList) => {
    console.debug("handleDelete", { setList });
    if (!setList) throw new Error("SetList not found");
    setListRemove({ setList });
    window.analyticsLogEvent("Deleted SetList", { setList });
  };

  if (isEmpty(setLists)) {
    return (
      <div className="my-2 py-2 px-4 text-accent-content">
        No set lists in your Songbook
      </div>
    );
  }

  const modalId = "delete-set-list-modal";
  return (
    <div className="py-2">
      {setListsArray.map((setList) => (
        <div
          className="flex items-center p-4 pr-0 text-accent-content justify-between"
          key={setList.id}
        >
          <Link
            href={`/setlist/${setList.id}/${setList.title}`}
            className="flex-1 cursor-pointer"
          >
            <div className="text-base">{setList.title}</div>
            <div className="text-sm">
              {setList?.songIds?.length} songs,{" "}
              {fromNowOrNow(setList.updated_timestamp)}
            </div>
          </Link>

          {setList.created_by_user_id === user?.id && (
            <div className="dropdown dropdown-end">
              <label className="btn btn-circle btn-ghost text-2xl text-accent-content">
                <MdMoreVert />
              </label>
              <ul className="dropdown-content z-10 menu p-0 bg-base-300 rounded border-[1px] border-[#ffffff40]">
                <DropdownItem onClick={() => handleClickRename(setList)}>
                  <MdModeEdit className="text-2xl" />
                  <span className="flex-1">Rename</span>
                </DropdownItem>

                <DropdownItem>
                  <label
                    htmlFor={`${modalId}-${setList.id}`}
                    className="modal-button flex flex-nowrap w-full rounded-none whitespace-nowrap"
                  >
                    <MdOutlineDelete className="text-2xl mr-3" />
                    Delete
                  </label>
                </DropdownItem>
                <Modal id={`${modalId}-${setList.id}`}>
                  <h3 className="font-bold text-lg">Delete Song</h3>
                  <div className="divider" />
                  <div>
                    Delete “{setList.title}” from your Songbook?“
                    <div className="modal-action">
                      <label
                        htmlFor={`${modalId}-${setList.id}`}
                        className="btn btn-outline ml-auto mr-2"
                      >
                        Cancel
                      </label>
                      <button
                        className="btn btn-secondary text-base-100"
                        onClick={() => handleDelete(setList)}
                        type="button"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </Modal>
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
